
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPipeCorner as ObiPipeCornerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pipe-corner.js';
 
 
 

 
 export const ObiPipeCorner = createComponent({
   react: React,
   tagName: 'obi-pipe-corner',
   elementClass: ObiPipeCornerElement,
   events: {
     
   }
  });
 
 